<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="51"
    viewBox="0 0 64 51"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25ZM18.2481 48.9999H14.7657H18.2481Z"
      fill="white"
    />
    <path
      d="M18.2481 48.9999H14.7657M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25Z"
      stroke="#1F64E7"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.5563 11.1711C24.5563 27.2827 39.0666 40.5589 57.7502 42.3513C55.4089 45.2305 51.793 47.1837 47.6736 47.4905V47.4999H14.1216C10.0507 47.4999 3.25 45.7847 3.25 38.274C3.25 30.7633 8.5371 29.0482 14.1216 29.0482C14.359 29.0482 14.5946 29.0556 14.828 29.0703C14.6658 28.2276 14.6373 27.359 14.5812 26.4735C14.2019 20.4919 16.8115 12.9532 24.5653 10.4998C24.5591 10.7234 24.5563 10.947 24.5563 11.1711ZM29.8083 36.3788C28.2889 36.3788 27.0572 37.5959 27.0572 39.0973C27.0572 40.5987 28.2889 41.8158 29.8083 41.8158C31.3276 41.8158 32.5593 40.5987 32.5593 39.0973C32.5593 37.5959 31.3276 36.3788 29.8083 36.3788Z"
      fill="#E8F0FE"
    />
    <path
      d="M30.002 42.0003C31.5208 42.0003 32.752 40.769 32.752 39.2503C32.752 37.7315 31.5208 36.5002 30.002 36.5002C28.4832 36.5002 27.252 37.7315 27.252 39.2503C27.252 40.769 28.4832 42.0003 30.002 42.0003Z"
      stroke="#1F64E7"
      stroke-width="2.5"
    />
    <path
      d="M22.25 33.5001L25.75 30.7536L22.25 28.1389"
      stroke="#1F64E7"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.75 33.5001L34.25 30.7536L37.75 28.1389"
      stroke="#1F64E7"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.7505 12.5002C38.005 13.3615 40.5747 15.9067 41.4707 19.1469"
      stroke="#75A4FE"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M45.252 4.00001C46.0804 4.00001 46.752 3.32844 46.752 2.50001C46.752 1.67158 46.0804 1 45.252 1C44.4235 1 43.752 1.67158 43.752 2.50001C43.752 3.32844 44.4235 4.00001 45.252 4.00001Z"
      stroke="#75A4FE"
      stroke-width="2"
    />
    <path
      d="M60.75 11.9998C61.5784 11.9998 62.25 11.3282 62.25 10.4998C62.25 9.67133 61.5784 8.99976 60.75 8.99976C59.9216 8.99976 59.25 9.67133 59.25 10.4998C59.25 11.3282 59.9216 11.9998 60.75 11.9998Z"
      fill="#75A4FE"
    />
    <path
      d="M49.1309 7.87842L53.31 12.0575M53.3735 7.87842L49.1944 12.0575L53.3735 7.87842Z"
      stroke="#75A4FE"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.95117 16.7986L4.95118 19.7986M4.95118 16.7986L1.95117 19.7986L4.95118 16.7986Z"
      stroke="#75A4FE"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.75001 13.4998C9.57844 13.4998 10.25 12.8282 10.25 11.9998C10.25 11.1713 9.57844 10.4998 8.75001 10.4998C7.92158 10.4998 7.25 11.1713 7.25 11.9998C7.25 12.8282 7.92158 13.4998 8.75001 13.4998Z"
      fill="#75A4FE"
    />
  </svg>
</template>
